import './App.css';
import {  Route, Routes } from 'react-router-dom';
import HomePage from './components/homePage';
import NavBar from './components/navBar';
import Footer from './components/Footer';
import Contact from './components/contactPage';
import Team from './components/team';
import teamData from './components/teamData';
import Articles from './components/articles';
import Sustainability from './components/sustainability';
import HowWeCanHelp from './components/howWeCanHelp';
import AboutUs from './components/aboutUs';
import Start2025WithABang from './components/blogs/start-2025-with-a-bang';
import StartWithWhyRememberHow from './components/blogs/start-with-the-why-remember-the-how';
import PowerOfMindset from './components/blogs/power-of-mindset';
import PrivacyPolicy from './components/privacyPolicy';
import Cookies from './components/cookies';
import salesData, { leadershipData, marketingData, medicalData } from './components/productData';
import articleData from './components/articlesData';
import clientData from './components/clientData';


function App() {
  return (
    <div className="App">
      <NavBar />
      <Routes>
        <Route path="/" element={<HomePage data={clientData}/>} />
        <Route path="/aboutUs" element={<AboutUs/>} />
        <Route path="/howWeCanHelp" element={<HowWeCanHelp salesData={salesData} marketingData = {marketingData} medicalData = {medicalData} leadershipData = {leadershipData}/>} />
        <Route path="/articles" element={<Articles articleData={articleData}/>} />
        <Route path="/sustainability" element={<Sustainability/>} />
        <Route path="/contact" element={<Contact/>} />
        <Route path="/team" element={<Team data={teamData}/>} />
        <Route path="/start-2025-with-a-bang" element={<Start2025WithABang/>} />
        <Route path="/start-with-the-why-remember-the-how" element={<StartWithWhyRememberHow/>} />
        <Route path="/the-power-of-your-mindset" element={<PowerOfMindset/>} />
        <Route path="/privacyPolicy" element={<PrivacyPolicy/>} />
        <Route path="/cookies" element={<Cookies/>} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
